import axios from 'axios'
import type { ApiErrorPayload } from './types'

export class AppError extends Error {
  readonly code?: number
  readonly requestId?: string

  constructor(message: string, code?: number, requestId?: string) {
    super(message)
    this.name = 'AppError'
    this.code = code
    this.requestId = requestId
  }
}

export function normalizeApiError(error: unknown): AppError {
  if (error instanceof AppError) return error

  if (axios.isAxiosError<ApiErrorPayload>(error)) {
    if (error.code === 'ECONNABORTED') {
      return new AppError('请求超时，请检查网络后重试')
    }

    const payload = error.response?.data
    return new AppError(
      payload?.message ?? error.message ?? '网络请求失败',
      payload?.code ?? error.response?.status,
      payload?.requestId,
    )
  }

  if (error instanceof Error) return new AppError(error.message)
  return new AppError('发生未知错误，请稍后重试')
}
